// geolocation.js
/**
 * Captura a localização atual do navegador de forma não-bloqueante.
 * Reaproveita o mesmo padrão usado em WeatherPanel.jsx: nunca rejeita,
 * nunca lança — em caso de permissão negada, timeout ou API ausente,
 * resolve com null e o chamador segue o fluxo normalmente sem localização.
 *
 * accuracy (pos.coords.accuracy, em metros) vai junto — usada como
 * tolerancia no geofence de desafio (Challenge.location_radius_m, ver
 * user_service.py::_checkin_within_challenge_radius), pra nao penalizar
 * check-in legitimo com GPS impreciso (comum dentro de academia/predio).
 *
 * @returns {Promise<{lat: number, lon: number, accuracy: number|null} | null>}
 */
export function getCurrentPositionSafe() {
  return new Promise((resolve) => {
    if (!navigator.geolocation) return resolve(null);
    navigator.geolocation.getCurrentPosition(
      (pos) => resolve({
        lat: pos.coords.latitude,
        lon: pos.coords.longitude,
        accuracy: pos.coords.accuracy ?? null,
      }),
      () => resolve(null),
      // Timeout generoso: se for a primeira solicitação de geolocalização da
      // sessão, o navegador mostra um prompt de permissão nativo — o usuário
      // pode levar mais de 4s pra notar e responder, especialmente no
      // mobile. 4s era curto demais e fazia o check-in seguir sem
      // localização mesmo quando o usuário concedia a permissão logo em
      // seguida.
      { maximumAge: 60_000, timeout: 10_000 }
    );
  });
}
